module.exports = __webpack_public_path__ + "media/images/proof_links/airbnb-4525c7c04307ac5b486973a99e77e39e.svg";